<span [ngSwitch]="id">
  <span class="badge bg-warning" *ngSwitchCase="0"> {{'statusValue.'+id | translate}}</span>
  <span class="badge bg-danger" *ngSwitchCase="2"> {{'statusValue.'+id | translate}}</span>
  <span class="badge bg-success" *ngSwitchDefault> {{'statusValue.'+id | translate}}</span>
</span>
